<script setup>
import {computed} from "vue"
import moment from "moment"

const props = defineProps({
    value: String
})

const formattedDate = computed(() => {
    if (props.value) {
        return moment(props.value).format("DD MMM YYYY")
    }
})
</script>

<template>
    <span>{{ formattedDate }}</span>
</template>